<template>
  <Navbar/>
  <Slider :category="category"/>
  <LearningPaths :id="id"/>
  <Courses :id="id"/>
  <Teachers :id="id"/>
</template>

<script>
import Navbar from "@/components/category/Navbar";
import Slider from "@/components/category/Slider";
import LearningPaths from "@/components/category/LearningPaths";
import Courses from "@/components/category/Courses";
import Teachers from "@/components/category/Teachers";
import axios from "axios";

export default {
  components: {Navbar, Slider, LearningPaths, Courses, Teachers},
  props: ['id'],
  data() {
    return {
      category: {},
    }
  },
  async mounted() {
    await axios.get(`/api/v3/interests/${this.id}`)
        .then((response) => {
          this.category = response.data;
        })
  }
}
</script>
